import React from "react"
import * as Icon from "react-feather"
import API from "../helpers/api"

/*
const navigationConfig = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    icon: <Icon.Home size={20} />,
    navLink: "/"
  },
  {
    type: "groupHeader",
    groupTitle: "MAIN"
  },
  {
    id: "vesselmanager",
    title: "Vessel Manager",
    type: "item",
    icon: <Icon.Anchor size={20} />,
    permissions: [3,4],
    navLink: "/vessel"
  },
  {
    id: "equipmentexplorer",
    title: "Equipment",
    type: "item",
    icon: <Icon.Cpu size={20} />,
    permissions: [16],
    navLink: "/equipment"
  },
  {
    id: "maintenance",
    title: "Maintenance",
    type: "item",
    icon: <Icon.Activity size={20} />,
    permissions: [5],
    navLink: "/maintenance"
  },
  {
    id: "maintenancehistory",
    title: "History",
    type: "item",
    icon: <Icon.BookOpen size={20} />,
    permissions: [5],
    navLink: "/history"
  },
  {
    id: "runninghours",
    title: "Running Hours",
    type: "item",
    icon: <Icon.Clock size={20} />,
    permissions: [17,18],
    navLink: "/runninghour"
  },
  {
    id: "report",
    title: "Report Tracking",
    type: "item",
    icon: <Icon.AlertTriangle size={20} />,
    permissions: [20,21,22,23],
    navLink: "/report"
  },
  {
    id: "exportimport",
    title: "Export /Import",
    type: "collapse",
    icon: <Icon.Folder size={20} />,
    children: [
      {
        id: "export",
        title: "Export",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: [1,2],
        navLink: "/export"
      },
      {
        id: "import",
        title: "Import",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: [1,2],
        navLink: "/import"
      },
    ]
  },
  {
    type: "groupHeader",
    groupTitle: "SETTINGS"
  },
  {
    id: "administration",
    title: "Administration",
    type: "collapse",
    icon: <Icon.UserCheck size={20} />,
    children: [
      {
        id: "edituser",
        title: "User",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: [24,25],
        navLink: "/adm/user"
      },
      {
        id: "editgroup",
        title: "Group",
        type: "item",
        icon: <Icon.Circle size={12} />,
        permissions: [24,25],
        navLink: "/adm/group"
      },
    ]
  },
]
*/

function getIcon(icon){
  switch(icon){
    case 'dashboard':
      return <Icon.Home size={20} />

    case 'assets':
      return <Icon.Anchor size={20} />

    case 'equipment':
      return <Icon.Cpu size={20} />

    case 'maintenance':
      return <Icon.Activity size={20} />

    case 'maintenance-history':
      return <Icon.BookOpen size={20} />

    case 'running-hours':
      return <Icon.Clock size={20} />

    case 'report-tracking':
      return <Icon.AlertTriangle size={20} />

    case 'defect-report':
        return <Icon.AlertTriangle size={20} />

    case 'administration':
      return <Icon.UserCheck size={20} />

    case 'export-import':
      return <Icon.Folder size={20} />

    case 'finding':
      return <Icon.GitPullRequest size={20} />

    case 'description':
      return <Icon.AlignLeft size={20} />

    case 'certificate':
      return <Icon.Award size={20} />

    case 'certificate-history':
      return <Icon.Book size={20} />

    case 'requisition':
      return <Icon.Activity size={20} />

    default:

      if(icon && Icon[icon]){
        return React.createElement(Icon[icon],{size:20})
      }

      return <Icon.Circle size={12} />
  }


}
function menuCreate(k,isChild=false){

  let type_role;

  switch(k.type_role){
    case 'menu-item':
      type_role = 'item';
      break;
    case 'group-header':
      type_role = 'groupHeader';
      break;
    case 'menu':
      type_role = 'collapse';
      break;
    default:
      type_role = k.type_role;
  }

  let mm = {
    'key_role': k.key_role,
    'type': type_role
  }

  if(k.icon && type_role !== 'groupHeader'){
    mm.id = k.tid
    mm.title = k.title
    mm.icon = (isChild) ? <Icon.ArrowRightCircle size={20} /> : getIcon( JSON.parse(k.icon).web )
  }else{
    mm.groupTitle = k.title
  }


  if(k.nav_link && (type_role !== 'groupHeader' && type_role !== 'collapse')){
    mm.navLink = k.nav_link
    //mm.parentOf = [k.nav_link + '/edit']
  }


  if(typeof k.allow_add !== 'undefined'){
    mm.permission = {
      'allow_add': k.allow_add,
      'allow_update': k.allow_update,
      'allow_delete': k.allow_delete
    }
  }

  return mm;
}

function getNavigationConfig(callback){
  API.get('/v1/users/modules',{
    callback:(cb)=>{

      if(!cb.success){
        return callback(cb.data)
      }
      let menu = [];
      let data = cb.data || []

      data.forEach((k)=>{

        if(k.type_menu !== 'mobile'){

          let mm = menuCreate(k)

          if(k.children){
            mm.children = []
            k.children.forEach((k2)=>{

              if(k.type_menu !== 'mobile'){
                mm.children.push(menuCreate(k2,true))
              }
            })
          }
          menu.push(mm)

        }

      })
      //console.log(menu)
      callback(false,menu)
    }
  })
}

export default getNavigationConfig

